import styled from "@emotion/styled";
import { FieldValues, useFormContext } from "react-hook-form";
import { CustomComponent } from "@kaltura/mediaspace-shared-ui";
import { KmsTypeComponent } from "@kaltura/mediaspace-shared-types";

interface ComponentsFormProps {
    formId: string;
    fields: KmsTypeComponent[];
    onSubmit: (data: FieldValues) => void;
}

const StyledForm = styled("form")(({ theme }) => ({
    marginBottom: theme.spacing(3),
}));

/**
 * form made of components - use for details, setting forms
 */
export const ComponentsForm = (props: ComponentsFormProps) => {
    const { formId, fields, onSubmit } = props;

    const methods = useFormContext();

    return (
        <StyledForm id={formId} onSubmit={methods.handleSubmit(onSubmit)}>
            {fields.map((field) => (
                <CustomComponent component={field} key={field.name + field.props.id} />
            ))}
        </StyledForm>
    );
};

export default ComponentsForm;
